/* Restaurant Halong: schlichtes Rabattcode-Feld im Warenkorb (Drawer und Warenkorbseite).
   Setzt den Code wie der Link /discount/CODE (Cookie discount_code); angewendet wird er an der Kasse.
   Wird vor halong-rollen.js geladen. Texte englisch, Anrede neutral. */
(function () {
  'use strict';
  window.HalongRollenCodefeld = function (w, abgleichen) {
    var doc = w.document;
    var wurzel = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
    var CSS = '.hk-code{margin:0 0 16px;font-family:Raleway,sans-serif;color:#1A1A1A}' +
      '.hk-code__row{display:flex;gap:8px}' +
      '.hk-code input{flex:1;min-width:0;height:44px;padding:0 16px;border:1px solid #1A1A1A;border-radius:999px;background:#fff;font:inherit;color:#1A1A1A}' +
      '.hk-code button{height:44px;padding:0 20px;border:1px solid #1A1A1A;border-radius:999px;background:#1A1A1A;color:#fff;font:inherit;font-weight:600;cursor:pointer}' +
      '.hk-code button.hk-code__ghost{background:transparent;color:#1A1A1A}' +
      '.hk-code__msg{margin:8px 0 0;font-size:14px;color:#4A4A4A}';
    var stil = doc.createElement('style'); stil.textContent = CSS; doc.head.appendChild(stil);

    function aktuellerCode() {
      var m = doc.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      try { return m ? decodeURIComponent(m[1]).trim() : ''; } catch (e) { return ''; }
    }
    function setzeCode(c) {
      return w.fetch(wurzel + 'discount/' + encodeURIComponent(c), { credentials: 'same-origin', redirect: 'follow' });
    }
    function loescheCode() { doc.cookie = 'discount_code=; Max-Age=0; path=/'; }

    function bauen() {
      var box = doc.createElement('div'); box.className = 'hk-code'; box.setAttribute('data-hk-code', '');
      var c = aktuellerCode();
      if (c) {
        box.innerHTML = '<div class="hk-code__row"><span style="flex:1;align-self:center"></span><button type="button" class="hk-code__ghost">Remove</button></div><p class="hk-code__msg">Applied at checkout, if the code is valid.</p>';
        box.querySelector('span').textContent = 'Code: ' + c;
        box.querySelector('button').addEventListener('click', function () { loescheCode(); neuZeichnen(); abgleichen(); });
      } else {
        box.innerHTML = '<form class="hk-code__row" novalidate><input type="text" name="hk-code" placeholder="Discount code" aria-label="Discount code" autocomplete="off" autocapitalize="characters"><button type="submit">Apply</button></form><p class="hk-code__msg" role="status" hidden></p>';
        var form = box.querySelector('form'), msg = box.querySelector('.hk-code__msg');
        form.addEventListener('submit', function (e) {
          e.preventDefault(); e.stopPropagation();
          var wert = form.elements['hk-code'].value.trim();
          if (!wert) { msg.hidden = false; msg.textContent = 'Please enter a code.'; return; }
          setzeCode(wert).then(function () { neuZeichnen(); abgleichen(); }).catch(function () { msg.hidden = false; msg.textContent = 'The code could not be saved. Please try again.'; });
        });
      }
      return box;
    }
    function ziele() {
      return [].slice.call(doc.querySelectorAll('cart-drawer [slot="footer"], .cart-form'));
    }
    function einsetzen() {
      ziele().forEach(function (ziel) {
        if (ziel.querySelector(':scope > [data-hk-code]')) return;
        ziel.insertBefore(bauen(), ziel.firstChild);
      });
    }
    function neuZeichnen() {
      [].slice.call(doc.querySelectorAll('[data-hk-code]')).forEach(function (n) { n.remove(); });
      einsetzen();
    }
    var t = null;
    new MutationObserver(function () { w.clearTimeout(t); t = w.setTimeout(einsetzen, 50); }).observe(doc.body, { childList: true, subtree: true });
    einsetzen();
  };
})();
